module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2-mobile@3x.507743a946b6054d6fd8e61bf40cd7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2-mobile@3x.jpg
// module id = 196
// module chunks = 13